import { baseApi } from "./baseApi";

const bookingApi: any = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBookings: builder.query({
      query: (params) => {
        let url = "bookings";

        url += "?";

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.page_size) {
          url += `page_size=${params.page_size}&`;
        }

        if (params.status) {
          url += `status=${params.status}&`;
        }
        if (params.brand_booking_status) {
          url += `brand_booking_status=${params.brand_booking_status}&`;
        }
        if (params.is_first_contact) {
          url += `is_first_contact=${params.is_first_contact}&`;
        }
        if (params.brand_id) {
          url += `brand_id=${params.brand_id}&`;
        }
        if (params.city_id) {
          url += `city_id=${params.city_id}&`;
        }
        if (params.contact_number) {
          url += `contact_number=${params.contact_number}&`;
        }
        if (params.customer_name) {
          url += `customer_name=${params.customer_name}&`;
        }
        if (params.assigned_city_manager_id) {
          url += `assigned_city_manager_id=${params.assigned_city_manager_id}&`;
        }
        if (params.zone_id) {
          url += `zone_id=${params.zone_id}&`;
        }
        if (params.partner_id) {
          url += `partner_id=${params.partner_id}&`;
        }
        if (params.agent_id) {
          url += `agent_id=${params.agent_id}&`;
        }
        if (params.brand_booking_code) {
          url += `brand_booking_code=${params.brand_booking_code}&`;
        }
        if (params.ecb_code) {
          url += `ecb_code=${params.ecb_code}&`;
        }
        if (params.start_date) {
          url += `start_date=${params.start_date}&`;
        }
        if (params.end_date) {
          url += `end_date=${params.end_date}&`;
        }
        if (params.next_follow_up_start) {
          url += `next_follow_up_start=${params.next_follow_up_start}&`;
        }
        if (params.next_follow_up_end) {
          url += `next_follow_up_end=${params.next_follow_up_end}&`;
        }
        if (params.state_id) {
          url += `state_id=${params.state_id}&`;
        }
        if (params.unassigned) {
          url += "unassigned=true&";
        }

        if (params.unassigned === false) {
          url += "unassigned=false&";
        }

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }
        return url;
      }
    }),
    getBookingById: builder.query({
      query: (id) => `bookings/${id}`
    }),
    createBooking: builder.mutation({
      query: (data) => ({
        url: "bookings",
        method: "POST",
        body: data
      })
    }),
    updateBooking: builder.mutation({
      query: (data) => ({
        url: `bookings/${data?.booking?.id}`,
        method: "PUT",
        body: data
      })
    }),
    // {{Server}}/api/v1/bookings/84/cancel?reason=CustomerRefused
    cancelBooking: builder.mutation({
      query: (data) => ({
        url: `bookings/${data?.id}/cancel?reason=${data?.reason}`,
        method: "PUT"
      })
    }),
    // {{Server}}/api/v1/bookings/84/on_hold?reason=DealerRequest
    onHoldBooking: builder.mutation({
      query: (data) => ({
        url: `bookings/${data?.id}/on_hold?reason=${data?.reason}`,
        method: "PUT"
      })
    }),
    deleteBooking: builder.mutation({
      query: (id) => ({
        url: `bookings/${id}`,
        method: "DELETE"
      })
    }),
    createCustomerConnectLogForBooking: builder.mutation({
      query: (data) => ({
        url: `bookings/${data?.id}/add_customer_connect_log`,
        method: "POST",
        body: data
      })
    }),
    updateCustomerConnectLogForBooking: builder.mutation({
      query: (data) => ({
        url: `bookings/${data?.id}/edit_customer_connect_log`,
        method: "PUT",
        body: data
      })
    }),
    getCustomerConnectLogsForBooking: builder.query({
      query: (id) => ({
        url: `bookings/${id}/customer_connect_logs`,
        method: "GET"
      })
    })
  })
});

export const {
  useGetBookingsQuery,
  useLazyGetBookingByIdQuery,
  useCreateBookingMutation,
  useUpdateBookingMutation,
  useCancelBookingMutation,
  useOnHoldBookingMutation,
  useDeleteBookingMutation,
  useCreateCustomerConnectLogForBookingMutation,
  useGetCustomerConnectLogsForBookingQuery,
  useUpdateCustomerConnectLogForBookingMutation
} = bookingApi;
